import { LoadPanel } from 'devextreme-react';
import { observer } from 'mobx-react';
import React, { useCallback, useEffect, useState } from 'react';
import CallServiceSearchV2 from './call-service-search-v2';
import CallServiceSearchStore from './call-service-search-store';
import moment from 'moment';

const CallServiceSearchContainer = () => {
  //console.log('CallServiceSearchContainer Load');

  const { callServiceSearch } = CallServiceSearchStore;

  const [useInfo, setUseInfo] = useState({
    // FromDate: moment().add(-1, 'months').format('YYYYMMDD'),
    // ToDate: moment().add(-1, 'days').format('YYYYMMDD')
    FromDate: moment().format('YYYYMMDD'),
    ToDate: moment().format('YYYYMMDD')
  });

  useEffect(() => {
    CallServiceSearchStore.getCusEntReceiptListSearch();
  }, []);

  const onValueChanged = useCallback((name, e) => {
    const { value, event } = e;
    let isDate = false;

    if (name === 'FromDate' || name === 'ToDate') {
      if (event) {
        isDate = true;
      } else {
        return;
      }
    }

    setUseInfo((useInfo) => ({
      ...useInfo,
      [name]: isDate ? moment(value).format('YYYYMMDD') : value,
    }));
  }, []);

  const onClickSearch = useCallback(async () => {
    const result = await CallServiceSearchStore.getCusEntReceiptListSearch(
      useInfo.FromDate,
      useInfo.ToDate,
    );
  }, [useInfo]);

  if (!useInfo) {
    return;
  }

  return (
    <CallServiceSearchV2
      onClickSearch={onClickSearch}
      callServiceSearch={callServiceSearch}
      useInfo={useInfo}
      onValueChanged={onValueChanged}
    />
  );
};

export default React.memo(observer(CallServiceSearchContainer));
